"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const react_router_dom_1 = require("react-router-dom");
const permissions_1 = require("@Const/permissions");
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
const clsx_1 = __importDefault(require("clsx"));
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const mobx_react_1 = require("mobx-react");
const RightsholderSubNavigationMobile = () => {
    const { rightsholderStore, rightsholderUserStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const currentRightsHoldersId = rightsholderStore.currentRightsholderId;
    const memberSummary = rightsholderStore.memberSummary;
    const hasManageContactPermission = rightsholderUserStore.doesRHUserHavePermissionOrIsInternal(permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address);
    const hasManageBankingPermission = rightsholderUserStore.doesRHUserHavePermissionOrIsInternal(permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax);
    return (react_1.default.createElement("div", { className: 'rightsholder-sub-navigation-mobile' },
        react_1.default.createElement("div", { className: 'mobile-menu-head' },
            react_1.default.createElement("img", { src: common_1.ICONS.account, alt: "Accounts" }),
            react_1.default.createElement("h4", { title: memberSummary.name, className: 'text-white' }, memberSummary.name)),
        react_1.default.createElement("div", { className: 'tabs' },
            react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.summary(currentRightsHoldersId), className: ({ isActive }) => (0, clsx_1.default)('small-2 bold', isActive && 'tab-active') }, "Summary"),
            react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_works] },
                react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.catalog.root(currentRightsHoldersId), className: ({ isActive }) => (0, clsx_1.default)('small-2 bold', isActive && 'tab-active') }, "Catalog")),
            (hasManageContactPermission || hasManageBankingPermission) && (react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.maintenance.root(currentRightsHoldersId), className: ({ isActive }) => (0, clsx_1.default)('small-2 bold', isActive && 'tab-active') }, "Member Settings")))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderSubNavigationMobile);
